export default [
  {
    path: "/stunting",
    component: () => import("@/pages/stunting/stunting-list.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
  {
    path: "/stunting/import/",
    component: () => import("@/pages/stunting/stunting-import.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
  {
    path: "/stunting/new/",
    component: () => import("@/pages/stunting/stunting-form.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
  {
    path: "/stunting/update/:id",
    component: () => import("@/pages/stunting/stunting-form.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
  {
    path: "/stunting/detail/:id",
    component: () => import("@/pages/stunting/stunting-detail.vue"),
    meta: {
      requiredLevel: ["admin", "kesehatan"],
    },
  },
];
